// extracted by mini-css-extract-plugin
export default {"header":"header_header__Xrmhv","child":"header_child__IDKr7"};